<template>
  <div>
    <v-app-bar
      color="primary"
      dark
      app
      clipped-left
      clipped-right
      outlined
    >
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
      />
      <v-toolbar-title
        :class="$vuetify.breakpoint.xs ? 'pb-1 pl-1' : 'pb-1'"
        style="cursor: pointer"
        @click="onLogoClicked"
      >
        <v-img
          :width="$vuetify.breakpoint.smAndDown ? '158px' : '198px'"
          :height="$vuetify.breakpoint.smAndDown ? '40px' : '50px'"
          src="/img/quats-text-white.png"
        />
        <!--        {{ $vuetify.breakpoint.smAndDown ? 'QUATS' : 'Achievement QUATS' }}-->
      </v-toolbar-title>
      <v-spacer />
      <lang-switcher />
      <v-btn
        icon
        @click="onLogoutClick"
      >
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      width="320"
      :mini-variant.sync="mini"
      clipped
      left
    >
      <v-list-item class="py-2">
        <v-list-item-content>
          <v-list-item-title
            class="primary--text font-weight-bold"
            style="font-size: 1.15rem;"
          >
            {{ companyName }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="my-1" />
      <v-list
        nav
        dense
        class="px-2"
      >
        <v-list-item-group
          v-model="selectedNavItem"
          color="primary"
        >
          <v-list-item
            v-for="(navItem, index) in navigationGroups.filter(page => page.isShow)"
            :key="`${index}`"
            color="primary"
            :href="navItem.href"
            target="_blank"
            @click="navItem.route ? navigate(navItem) : ''"
          >
            <v-list-item-icon>
              <v-icon
                dense
                color="primary"
              >
                {{ navItem.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">
                {{ $t(`navigation_list.${navItem.title}`) }}
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon v-if="navItem.href">
              <v-icon
                dense
                color="grey"
              >
                mdi-open-in-new
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import LangSwitcher from './LangSwitcher'
import QUATSError from '../plugins/error'
export default {
  name: 'NavBar',
  components: { LangSwitcher },
  data: () => ({
    selectedNavItem: null,
    drawer: false,
    mini: false,
    loading: false,
    companyLocalName: null
  }),
  computed: {
    /**
     * @desc compute company name
     * */
    companyName() {
      if (this.companyLocalName == null) {
        return this.$t('common.loading')
      }
      return this.companyLocalName
    },

    /**
       * @desc get the navigation data from the stores
       * @returns {any}
       */
    navigationGroups() {
      return this.$store.getters['account/navGroups']
    },

    /**
       * @desc get value of the navigation drawer controller
       * @returns {boolean}
       */
    controlNavigation () {
      return this.$store.state.account.controlNavigation
    }
  },
  watch: {
    /**
       * @desc watch the control navigation if it changes it will close the drawer
       */
    controlNavigation () {
      this.drawer = false
    }
  },
  /**
   * @desc On Created, Pull Parent Company Information to be shown on this component
   * */
  created() {
    if(this.$store.state.account.user) {
      window.axios.get('/api/navigation/parent-company')
        .then(res => {
          this.companyLocalName = res.data.data.data.name
        }).catch(err => {
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
        })
    }

    /* update nav bar active item on initial page load */
    this.selectedNavItem = this.navigationGroups.findIndex((page) => this.$route.matched.find(route => route.name === page.route?.name)) || null
  },
  methods: {
    /**
       * @desc function that will log user out of the current system
       * @returns {Promise<unknown>}
       */
    onLogoutClick() {
      this.loading = true
      return window.axios.post('/api/auth/logout', {})
        .then(() => {
          this.$store.commit('account/user', null)
          window.location.reload(true)
        }).catch(err => {
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
        }).finally(() => {
          this.loading = false
        })
    },
    /**
     * @desc to correctly push user on link click
     * */
    navigate (page) {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.drawer = false
      }
      if (!this.$route.matched.find((route) => route.name === page.route.name)) {
        this.$router.push(page.route)
      }
    },
    /**
     * @desc to handle when user click on quats logo
     */
    onLogoClicked () {
      if (this.$route.name === 'Home') {
        this.$router.go(0)
      } else {
        this.$router.push('/homepage')
      }
    }
  }
}
</script>

<style scoped>

</style>
